module.exports = __webpack_public_path__ + "static/media/fa.0be1de68.jpg";